(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supercool-custom-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('supercool-sticky-header')) {
    class SupercoolStickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('.shopify-section') || this;
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.headerHeight = 0;
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.preventReveal = false;
        this.isScrolling = null;
        this.headerIsHidden = false;
        this.scrollThreshold = 8;
        this.scrollTicking = false;
        this.scrollRaf = null;
        this.mediaQuery = window.matchMedia('(max-width: 990px)');
        this.homepageRevealMediaQuery = window.matchMedia('(min-width: 750px)');
        this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
        this.refreshHomeBannerHandler = this.handleHomepageRevealBreakpointChange.bind(this);
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
          this.clearPreventRevealTimer();
        };
        this.isHomepage = this.dataset.isHomepage === 'true';
        this.homeBanner = null;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.setHeaderHeight();
        this.refreshHomeBanner();
        this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);
        this.homepageRevealMediaQuery.addEventListener('change', this.refreshHomeBannerHandler);
        if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }

      setHeaderHeight() {
        const headerHeight = Math.round(this.header.getBoundingClientRect().height);
        if (headerHeight === this.headerHeight) return;

        this.headerHeight = headerHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        this.mediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
        this.homepageRevealMediaQuery.removeEventListener('change', this.refreshHomeBannerHandler);
        if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
        this.clearPreventRevealTimer();
      }

      createObserver() {
        const observer = new IntersectionObserver((entries, activeObserver) => {
          this.headerBounds = entries[0].intersectionRect;
          activeObserver.disconnect();
        });
        observer.observe(this.header);
      }

      refreshHomeBanner() {
        if (!this.isHomepage) {
          this.homeBanner = null;
          return;
        }

        this.homeBanner = document.querySelector(
          'main .sc-natural-slideshow, main .sc-responsive-image-banner, main .slideshow, main .banner'
        );
      }

      forceHeaderVisibleInBanner() {
        if (this.headerIsAlwaysSticky) return;

        this.headerIsHidden = false;
        this.preventReveal = false;
        this.clearPreventRevealTimer();
        this.header.classList.remove(
          'scrolled-past-header',
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      handleHomepageRevealBreakpointChange() {
        this.refreshHomeBanner();

        if (!this.homepageRevealMediaQuery.matches && this.isHomepage) {
          this.reset();
        }
      }

      isInsideHomepageBanner() {
        if (!this.isHomepage || !this.homepageRevealMediaQuery.matches) return false;

        if (!this.homeBanner || !document.documentElement.contains(this.homeBanner)) {
          this.refreshHomeBanner();
        }

        if (!this.homeBanner) return false;

        return this.homeBanner.getBoundingClientRect().bottom > 0;
      }

      onScroll() {
        if (this.scrollTicking) return;

        this.scrollTicking = true;
        this.scrollRaf = window.requestAnimationFrame(() => {
          this.scrollTicking = false;
          this.scrollRaf = null;
          this.updateStickyHeader();
        });
      }

      updateStickyHeader() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const previousScrollTop = this.currentScrollTop;
        const scrollDelta = scrollTop - previousScrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (this.isInsideHomepageBanner()) {
          this.forceHeaderVisibleInBanner();
          this.currentScrollTop = scrollTop;
          return;
        }

        if (Math.abs(scrollDelta) < this.scrollThreshold) return;

        if (scrollDelta > 0) {
          this.clearPreventRevealTimer();
        }

        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');

          if (scrollDelta > 0) {
            this.hide();
          } else if (!this.preventReveal) {
            this.reveal();
          } else {
            this.startPreventRevealTimer();
            this.hide();
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          this.reset();
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.headerIsHidden = true;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.headerIsHidden = false;
        this.clearPreventRevealTimer();
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.headerIsHidden = false;
        this.preventReveal = false;
        this.clearPreventRevealTimer();
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      startPreventRevealTimer() {
        this.clearPreventRevealTimer();
        this.isScrolling = window.setTimeout(() => {
          this.preventReveal = false;
          this.isScrolling = null;
        }, 66);
      }

      clearPreventRevealTimer() {
        if (!this.isScrolling) return;
        window.clearTimeout(this.isScrolling);
        this.isScrolling = null;
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
      }
    }
    customElements.define('supercool-sticky-header', SupercoolStickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
